 export const MENUITEMS =  [
    {
        title: "General",
        menu: [
          {
            title: "Dashboard",
            icon: "home",
            type:"sub",
            menu: [
              { path: "/dashboard/default", title: "Default", type: "link"},
              { path: "/dashboard/ecommerce", title:"Ecommerce", type: "link"}
            ]
          },
          {
            title: "Widgets",
            icon: "airplay",
            type:"sub",
            menu: [
              { path: "/widgets/general", title: "General", type: "link"},
              { path: "/widgets/chart", title: "Chart", type: "link"}
            ]
          },
          {
            title: "PageLayout",
            icon: "layout",
            type:"sub",
            menu: [
              { path: "/pagelayout/footerlight", title: "FooterLight", type: "link"},
              { path: "/pagelayout/footerdark", title: "FooterDark", type: "link" },
              { path: "/pagelayout/footerfixed", title: "FooterFixed", type: "link"}
            ]
          }
        ]
      },
      {
        title: "Components",
        menu: [
          {
            title: "UiKits",
            type:"sub",
            icon: "box",
            menu: [
              { path: "/uikits/typography", title: "Typography", type: "link" },
              { path: "/uikits/avatars", title: "Avatars", type: "link" },
              { path: "/uikits/helperclasses", title: "Helperclasses", type: "link" },
              { path: "/uikits/grid", title: "Grid", type: "link" },
              { path: "/uikits/tag&pills", title: "Tag&Pills" , type: "link" },
              { path: "/uikits/progressbar", title: "Progress" , type: "link" },
              { path: "/uikits/modal", title: "Modal" , type: "link" },
              { path: "/uikits/alert", title: "Alert" , type: "link" },
              { path: "/uikits/popover", title: "Popover", type: "link"},
              { path: "/uikits/tooltip", title: "Tooltip", type: "link" },
              { path: "/uikits/spinners", title: "Spinners",type: "link" },
              { path: "/uikits/dropdown", title: "Dropdown" , type: "link" },
              { path: "/uikits/accordion", title: "Accordion", type: "link" },
              { 
                 title:"Tabs",
                 type: "sub",
                 menu:[
                    { title:"SveltestarpTabs", path: "/uikits/tabs/sveltestraptabs", type: "link" },
                    { title:"LineTabs", path: "/uikits/tabs/linetabs", type: "link" }
                 ]
              },
              { path: "/uikits/navs", title: "Navs" , type: "link" },
              { path: "/uikits/shadow", title: "Shadow", type: "link" },
              { path: "/uikits/lists", title: "Lists", type: "link" }
            ]
          },
          {
            title: "BonusUi",
            icon: "folder-plus",
            type:"sub",
            menu: [
              { path: "/bonusui/scrollable", title: "Scrollable", type: "link"},
              { path: "/bonusui/treeview", title:"Tree view" , type: "link" },
              { path: "/bonusui/toaster", title:"Toaster", type: "link" },
              { path: "/bonusui/rating", title:"Rating", type: "link" },
              { path: "/bonusui/dropzone", title:"dropzone", type: "link" },
              { path: "/bonusui/sweetalert", title:"Sweet Alert",type: "link"},
              { path: "/bonusui/owlcarousel", title:"Owl Carousel", type: "link"},
              { path: "/bonusui/ribbons", title:"Ribbons",type: "link" },
              { path: "/bonusui/pagination", title:"Pagination", type: "link"},
              { path: "/bonusui/step", title:"Steps", type: "link"},
              { path: "/bonusui/breadcrumb", title:"Breadcrumb",type: "link"},
              { path: "/bonusui/rangeslider", title:"Range Slider", type: "link" },
              { path: "/bonusui/imagecropper", title:"Image cropper", type: "link"},
              { path: "/bonusui/sticky", title:"Sticky", type: "link" },
              { path: "/bonusui/basiccard", title:"Basic Card", type: "link" },
              { path: "/bonusui/creativecard", title:"Creative Card", type: "link"},
              { path: "/bonusui/tabbedcard", title:"Tabbed Card", type: "link" },
              { path: "/bonusui/draggablecard", title:"Draggable Card", type: "link"},
              { title:"Timeline", path:"/bonusui/timeline", type: "link" }
            ]
          },
          {
            title: "Icons",
            icon: "command",
            type:"sub",
            menu: [
              { path: "/icons/flagicon", title: "FlagIcon", type: "link" },
              { path: "/icons/fontawesomeicon", title: "FontawesomeIcon", type: "link" },
              { path: "/icons/icoicon", title: "IcoIcon", type: "link" },
              { path: "/icons/themifyicon", title: "ThemifyIcon", type: "link" },
              { path: "/icons/feathericon", title: "FeatherIcon", type: "link" },
              { path: "/icons/whethericon", title: "WhetherIcon", type: "link" }
            ]
          },
          {
            title: "Buttons",
            icon: "cloud",
            type:"sub",
            menu: [
              { path: "/buttons/defaultstyle", title: "DefaultStyles", type: "link" },
              { path: "/buttons/flatstyle", title: "FlatStyle", type: "link" },
              { path: "/buttons/edgestyle", title: "EdgeStyle", type: "link" },
              { path: "/buttons/raisedstyle", title: "RaisedStyle", type: "link" },
              { path: "/buttons/buttongroup", title: "ButtonGroup", type: "link" }
            ]
          },
          {
            title: "Charts",
            icon: "bar-chart",
            type:"sub",
            menu: [
              { path: "/charts/apexchart", title: "Apex Chart", type: "link"},
              { path: "/charts/chatjschart", title:"Chatjs Chart", type: "link" },
            ]
          }
        ]
      },
      {
        title: "Forms",
        menu: [
            {
                title: "FormControls",
                icon: "sliders",
                type:"sub",
                menu: [
                { path: "/formcontrols/formvalidation", title: "Form Validation", type: "link" },
                { path: "/formcontrols/baseinputs", title:"Base Inputs", type: "link" },
                { path: "/formcontrols/checkboxradio", title:"Checkbox & Radio", type: "link" },
                { path: "/formcontrols/inputgroups", title:"Input Groups", type: "link"},
                { path: "/formcontrols/megaoptions", title:"Mega Options", type: "link"}
                ]
            },
            {
                title: "FormWidgets",
                icon: "package",
                type:"sub",
                menu: [
                { path: "/formwidgets/datepicker", title: "Datepicker", type: "link"},
                { path: "/formwidgets/timepicker", title:"Timepicker", type: "link" },
                { path: "/formwidgets/datetimepicker", title:"Datetimepicker", type: "link" 
                },
                { path: "/formwidgets/select2", title:"Select2", type: "link" },
                { path: "/formwidgets/switch", title:"Switch", type: "link"},
                { path: "/formwidgets/typeahead", title:"Typeahead", type: "link" },
                { path: "/formwidgets/clipboard", title:"Clipboard", type: "link" }
                ]
            },
            {
                title: "Formlayout",
                icon: "layout",
                type:"sub",
                menu: [
                { path: "/formlayout/defaultforms",title: "Default Forms", type: "link" },
                { path: "/formlayout/formwizard", title:"Form Wizard", type: "link"}
                ]
            }
        ]
      },
      {
        title: "Table",
        menu: [
            {
                title: "Sveltestrap Tables",
                icon: "server",
                type:"sub",
                menu: [
                  { path: "/sveltestraptable/basictables", title: "Basic Tables", type: "link" },
                  { path: "/sveltestraptable/sizingtables", title:"Sizing Tables", type: "link" },
                  { path: "/sveltestraptable/bordertables", title:"Border Tables", type: "link"},
                  { path: "/sveltestraptable/stylingtables",title:"Styling Tables", type: "link"},
                  { path: "/sveltestraptable/tablecomponents", title:"Table components", type: "link" }
                ]
            },
            {
                title: "DataTables",
                icon: "database",
                type:"link",
                path:"/table/datatable"
            }
        ]
      },
      {
        title: "Applications",
        menu: [
            {
                title: "Project",
                icon: "box",
                type:"sub",
                menu: [
                  { path: "/project/projectlist", title: "Project List", type: "link"},
                  { path: "/project/createnew", title:"Create new",type: "link" }
                ]
            },
            {
                title: "FileManager",
                icon: "git-pull-request",
                path:"/application/filemanager",
                type: "link"
            },
            {
                title: "Ecommerce",
                icon: "shopping-bag",
                type:"sub",
                menu: [
                    { path: "/ecommerce/product", title: "Product", type: "link" },
                    { path: "/ecommerce/productpage", title:"Product page", type: "link"},
                    { path: "/ecommerce/productlist", title:"Product list", type: "link"},
                    { path: "/ecommerce/paymentdetails", title:"Payment Details", type: "link" },
                    { path: "/ecommerce/orderhistory", title:"OrderHistory", type: "link"},
                    { path: "/ecommerce/invoice", title:"Invoice", type: "link" },
                    { path: "/ecommerce/cart", title:"Cart", type: "link" },
                    { path: "/ecommerce/wishlist", title:"Wishlist", type: "link" },
                    { path: "/ecommerce/checkout", title:"Checkout", type: "link"  },
                    { path: "/ecommerce/pricing", title:"Pricing", type: "link" }
                ]
            },
            {
                title: "Email",
                icon: "mail",
                type:"sub",
                menu: [
                    { path: "/email/mailinbox", title: "Mail Inbox", type: "link"},
                    { path: "/email/readmail", title:"Read mail",  type: "link"},
                    { path: "/email/compose", title:"Compose",  type: "link" }
                ]
            },
            {
                title: "Chat",
                icon: "message-circle",
                type:"sub",
                menu: [
                    { path: "/chat/chatapp", title: "Chat App",  type: "link" },
                    { path: "/chat/videochat", title:"Video chat",  type: "link"}
                ]
            },
            {
                title: "Users",
                icon: "users",
                type:"sub",
                menu: [
                    { path: "/users/usersprofile", title: "Users Profile", type: "link" },
                    { path: "/users/usersedit", title:"Users Edit", type: "link"  },
                    { path: "/users/userscards", title:"Users Cards", type: "link" }
                ]
            },
            {
                title: "Bookmarks",
                icon: "heart",
                path:"/apps/bookmarks",
                type: "link"
            
            },
            {
                title: "Contacts",
                icon: "list",
                path:"/apps/contacts",
                type: "link"
            
            },
            {
                title: "Tasks",
                icon: "check-square",
                path:"/apps/tasks",
                type: "link"
            },
            {
                title: "SocialApp",
                icon: "zap",
                path:"/apps/socialapp",
                type: "link"
            },
            {
                title: "Todo",
                icon: "clock",
                path:"/apps/todo",
                type: "link"
            },
            {
                title: "Search Result",
                icon: "search",
                path:"/apps/searchresult",
                type: "link"
            }
        ]
      },
      {
        title: "Pages",
        menu: [
            {
                title: "Sample page",
                icon: "file",
                path:"/pages/samplepage",
                type: "link"
            },
            {
                title: "Others",
                icon: "layers",
                type:"sub",
                menu: [
                    { 
                       title: "Errorpage",
                       type: "sub",
                       menu:[
                        { title:"Error page 1", path:"/errorpage/errorpage1", type: "link"},
                        { title:"Error page 2", path:"/errorpage/errorpage2", type: "link"},
                        { title:"Error page 3", path:"/errorpage/errorpage3", type: "link"},
                        { title:"Error page 4", path:"/errorpage/errorpage4", type: "link"}
                     ]
                    },
                    { 
                       title:"Authentication" ,
                       type: "sub",
                       menu:[
                        { title:"Login Simple", path:"/authentication/loginSimple",  type: "link"},
                        { title:"Login with bg image", path:"/authentication/loginwithbgimage", type: "link" },
                        { title:"Login with image two", path:"/authentication/loginwithimagetwo", type: "link"},
                        { title:"Login With validation",path:"/authentication/loginwithvalidation", type: "link" },
                        { title:"Login with tooltip", path:"/authentication/loginwithtooltip", type: "link" },
                        { title:"Login with sweetalert",  path:"/authentication/loginwithsweetalert", type: "link"},
                        { title:"Register Simple", path:"/authentication/registersimple", type: "link" },
                        { title:"Register with Bg Image", path:"/authentication/registerwithbgimage", type: "link" },
                        { title:"RegisterwithBgvideo", path:"/authentication/registerwithbgvideo", type: "link" },
                        { title:"Unlock User", path:"/authentication/unlockuser", type: "link" },
                        { title:"Forget Password", path:"/authentication/forgetpassword", type: "link" },
                        { title:"Creat Password", path:"/authentication/creatpassword", type: "link" },
                        { title:"Maintenance", path:"/authentication/maintenance", type: "link" }
                     ]
                    },
                    { 
                       title:"ComingSoon",
                       type: "sub",
                       menu:[
                        { title:"Coming Simple", path:"/comingsoon/comingsimple", type: "link" },
                        { title:"Coming with Bg video", path:"/comingsoon/comingwithbgvideo",type: "link"},
                        { title:"Coming with Bg Image", path:"/comingsoon/comingwithbgimage", type: "link" }
                     ]
                    }
                ]
            }
        ]
      },
      {
        title: "Miscellaneous",
        menu: [
            {
                title: "Gallery",
                icon: "image",
                type:"sub",
                menu: [
                    { path: "/gallery/gallerygrid", title: "Gallery Grid", type: "link" },
                    { path: "/gallery/gallerygriddesc", title: "Gallery Grid Desc", type: "link" },
                    { path: "/gallery/hovereffects", title: "Hover Effects", type: "link" }
                ]
            },
            {
                title: "Blog",
                icon: "edit",
                type:"sub",
                menu: [
                    { path: "/blog/blogdetails", title: "Blog Details", type: "link"},
                    { path: "/blog/blogsingle", title: "Blog Single", type: "link" },
                    { path: "/blog/addpost", title: "Add Post", type: "link"}
                ]
            },
            {
                title: "FAQ",
                icon: "help-circle",
                path:"/faq",
                type:"link"  
            },
            {
                title: "Job Search",
                icon: "user-check",
                type:"sub",
                menu: [
                    { path: "/jobsearch/cardsview", title: "Cards view", type: "link" },
                    { path: "/jobsearch/listview", title: "List View", type: "link" },
                    { path: "/jobsearch/jobdetails", title: "Job Details", type: "link" },
                    { path: "/jobsearch/apply", title: "Apply", type: "link" }
                ]
                
            },
            {
                title: "Learning",
                icon: "layers",
                type:"sub",
                menu: [
                    { path: "/learning/learninglist", title: "Learning List", type: "link" },
                    { path: "/learning/detailedcourse", title:"Detailed Course", type: "link"} 
                ]
            },
            {
              title: "Leaflet Maps",
              icon: "map",
              path:"/map/leafletmap",
              type:"link"
            },
            {
                title: "Knowledgebase",
                icon: "database",
                type:"sub",
                menu: [
                    { path: "/knowledge/knowledgebase", title: "Knowledgebase", type: "link"},
                    { path: "/knowledge/knowledgecategory", title:"Knowledge category", type: "link" },
                    { path: "/knowledge/knowledgedetail", title:"Knowledge detail", type: "link" } 
                ]
            },
            {
                title: "SupportTicket",
                icon: "headphones",
                path:"/supportticket",
                type:"link"
            }
        ]
      }
]





  